import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UtilityService } from '@app/_services/utility.service';
import { AUTH_ROUTE_PREFIX } from '@app/enums';
export const authGuard: CanActivateFn = () => {
  const utility = inject(UtilityService);
  const router = inject(Router);

  if (utility.isUserLoggedIn()) {
    return true;
  } else {
    utility.clearLocalStorage();
    router.navigate([`${AUTH_ROUTE_PREFIX}/login`]);
    return false;
  }
};
